import type { CoverTextCase } from 'fym-shared/src/music24/coverDoc';

/** The text in the case of the box. Pure. */
export function applyTextCase(text: string, textCase: CoverTextCase): string {
  if (textCase === 'upper') {
    return text.toUpperCase();
  }
  return textCase === 'lower' ? text.toLowerCase() : text;
}

/**
 * The width of a text with letter spacing: the spacing goes between the characters, not after
 * the last one. `measure` gives the width with no spacing. Pure.
 */
export function trackedWidth(text: string, trackingPx: number, measure: (text: string) => number): number {
  const count = Array.from(text).length;
  return measure(text) + Math.max(0, count - 1) * trackingPx;
}

/**
 * Wraps a text to `maxWidth`: a line end of the text starts a new line, and a line breaks between
 * words. A word wider than the box stays whole on its own line (the box shows it past its side,
 * like a slide editor). An empty line stays empty. `measure` gives the width of a text. Pure.
 */
export function wrapLines(text: string, maxWidth: number, measure: (text: string) => number): string[] {
  const lines: string[] = [];
  for (const paragraph of text.split(/\r?\n/)) {
    const words = paragraph.split(/[ \t]+/).filter((word) => word !== '');
    if (words.length === 0) {
      lines.push('');
      continue;
    }
    let line = '';
    for (const word of words) {
      const candidate = line === '' ? word : `${line} ${word}`;
      if (line !== '' && measure(candidate) > maxWidth) {
        lines.push(line);
        line = word;
      } else {
        line = candidate;
      }
    }
    lines.push(line);
  }
  return lines;
}
